'use client';

import { useRouter } from 'next/navigation';
import type { CreateFlow } from '@/utils/analytics-events';
import { trackCreate } from '@/utils/create-flow-analytics';
import {
  buildHandoff,
  setFormatHandoff,
  formatHref,
  handoffVariant,
  type FormatSnapshot,
} from '@/lib/create-flow/format-handoff';

export type SwitchSource = 'card' | 'strip' | 'preview' | 'mismatch';

/** Returns a function that hands the snapshot to the other flow, tracks the switch, then navigates. */
export function useFormatSwitch(from: CreateFlow) {
  const router = useRouter();
  return (snapshot: FormatSnapshot, o: { source: SwitchSource; step: string }): void => {
    const h = buildHandoff(from, snapshot);
    setFormatHandoff(h);
    trackCreate(from, 'format_switched', { product: h.to, step: o.step, source: o.source, variant: handoffVariant(h) });
    router.push(formatHref(h.to));
  };
}
